import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import { Row, Col } from 'reactstrap';

function BusinessSetups() {
  
  const featuresData = [
    {
      icon: 'flaticon-dashboard',
      bgColor: '#d0faec',
      title: 'Setups',
      description: 'Helping you to setup your Xero account.',
    },
    {
      icon: 'flaticon-relationship',
      bgColor: '#ffeff8',
      title: 'Addons',
      description: 'Helping you in identifying and setting up correct business structure.',
    },
    {
      icon: 'flaticon-solution',
      bgColor: '#d3f6fe',
      title: 'Training',
      description: 'Training and support for your accounting staff.',
    },
    {
      icon: 'flaticon-system',
      bgColor: '#fff5d9',
      title: 'Support',
      description: 'Supporting the business owners to achieve their goals.',
    },
  ];

  return (
    <div>
      <section>
        <div class="container" style={{ width: '70%', margin: '0 auto' }} >
          <div class="row align-items-center">
            <div class="col-lg-12 col-12">
              <div class="mb-5">
                <h1 class="mb-0"><span class="font-w-4 d-block text-center  ">Business Setups</span> </h1>
              </div>
              <Row>
                {featuresData.map((feature, index) => (
                  <Col key={index} md="6" className={`mt-5`}>
                    <div className="d-flex justify-content-between">
                      <div className="me-3">
                        <div className={`f-icon-s p-3 rounded`} style={{ backgroundColor: feature.bgColor }}>
                          <i className={feature.icon}></i>
                        </div>
                      </div>
                      <div>
                        <h5 className="mb-2">{feature.title}</h5>
                        <p className="mb-0">{feature.description}</p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}



export default BusinessSetups